function RiskMetricTable(props: RiskMetricProps) {
    const { title, headings, tableData } = props;

    return (
        <>
            <header className={'risk-metric-table-header'}>{title}</header>
            <table className={'risk-metric-table'}>
                <thead>
                    <tr>
                        {headings.length > 0 && headings?.map((c, i) => <th key={i}>{c.name}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {tableData.length > 0 &&
                        tableData?.map((r) => (
                            <tr key={r.id}>
                                <td key={r.id}>{r.name || 'name'}</td>
                                {r.data.map((td) => (
                                    <td key={td.key}>{td.pctFormatted || '?'}</td>
                                ))}
                            </tr>
                        ))}
                </tbody>
            </table>
        </>
    );
}

export interface RiskMetricProps {
    title: string;
    headings: Headings[];
    tableData: TableData[];
    typographyClass?: string;
}

interface Headings {
    key: string;
    name: string;
    targetIdPrefix: string;
}

interface TableData {
    id: string;
    name: string;
    data: {
        key: string;
        pct: number;
        pctFormatted: string;
        targetIdPrefix: string | null;
    }[];
}

export default RiskMetricTable;
